import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    update({ commit, dispatch }, model) {
      return ajax.put("CMS/api/Forums", model).then(() => {});
    },
    ConfirmSuggestionsAnswer({ commit, dispatch }, model) {
      return ajax.put("CMS/api/Suggestions", model).then(() => {});
    },
    createSurvey({ commit, dispatch }, model) {
      return ajax
        .post("CMS/api/Suggestions/organization", model)
        .then(() => {});
    },
    fetchAnswerSuggestionWithId({ commit, dispatch }, id) {
      return ajax.get("CMS/api/SuggestionsQuery/" + id).then(() => {});
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
